import { useAuthStore, type UserConfig } from "@/store/useAuthStore";

const BUILD_FALLBACKS = {
  enableLessonSequencing:
    import.meta.env.VITE_ENABLE_LESSON_SEQUENCING === "true",
  enableCurriculumManagement:
    import.meta.env.VITE_ENABLE_CURRICULUM_MANAGEMENT === "true",
  enableStudentLessonSchedule:
    import.meta.env.VITE_ENABLE_STUDENT_LESSON_SCHEDULE === "true",
  enablePacingMode: import.meta.env.VITE_ENABLE_PACING_MODE === "true",
  enableTranscriptions: import.meta.env.VITE_ENABLE_TRANSCRIPTIONS === "true",
  enableTypedChat: import.meta.env.VITE_ENABLE_TYPED_CHAT === "true",
  enableInkCrops:
    (import.meta.env.VITE_ENABLE_INK_CROPS ?? "true").toLowerCase() !== "false",
};

const orFallback = (value: unknown, fallback: boolean): boolean =>
  typeof value === "boolean" ? value : fallback;

const runtimeFlag = (
  read: (userConfig: UserConfig | undefined) => unknown,
  fallback: boolean,
) =>
  function useRuntimeFlag(): boolean {
    return useAuthStore((s) => orFallback(read(s.user?.config), fallback));
  };

export const useLessonSequencingEnabled = runtimeFlag(
  (userConfig) => userConfig?.enableLessonSequencing,
  BUILD_FALLBACKS.enableLessonSequencing,
);
export const useCurriculumManagementEnabled = runtimeFlag(
  (userConfig) => userConfig?.enableCurriculumManagement,
  BUILD_FALLBACKS.enableCurriculumManagement,
);
export const useStudentLessonScheduleEnabled = runtimeFlag(
  (userConfig) => userConfig?.enableStudentLessonSchedule,
  BUILD_FALLBACKS.enableStudentLessonSchedule,
);
export const usePacingModeEnabled = runtimeFlag(
  (userConfig) => userConfig?.enablePacingMode,
  BUILD_FALLBACKS.enablePacingMode,
);
export const useTranscriptionsEnabled = runtimeFlag(
  (userConfig) => userConfig?.enableTranscriptions,
  BUILD_FALLBACKS.enableTranscriptions,
);

export const useTypedChatEnabled = (): boolean =>
  useAuthStore(
    (s) =>
      BUILD_FALLBACKS.enableTypedChat ||
      s.user?.config?.enableTypedChat === true,
  );

export const inkCropsEnabled = (): boolean =>
  orFallback(
    useAuthStore.getState().user?.config?.enableInkCrops,
    BUILD_FALLBACKS.enableInkCrops,
  );
